/**
 * Cache duration constants in seconds
 * Used for cache expiration times across the application
 */

export const CACHE_DURATION = {
    /** 1 second */
    SECOND: 1,

    /** 10 seconds */
    SECONDS_10: 10,

    /** 30 seconds */
    SECONDS_30: 30,

    /** 1 minute (60 seconds) */
    MINUTE: 60,

    /** 5 minutes (300 seconds) */
    MINUTES_5: 5 * 60,

    /** 10 minutes (600 seconds) */
    MINUTES_10: 10 * 60,

    /** 15 minutes (900 seconds) */
    MINUTES_15: 15 * 60,

    /** 30 minutes (1800 seconds) */
    MINUTES_30: 30 * 60,

    /** 1 hour (3600 seconds) */
    HOUR: 60 * 60,

    /** 2 hours (7200 seconds) */
    HOURS_2: 2 * 60 * 60,

    /** 6 hours (21600 seconds) */
    HOURS_6: 6 * 60 * 60,

    /** 12 hours (43200 seconds) */
    HOURS_12: 12 * 60 * 60,

    /** 1 day (86400 seconds) */
    DAY: 24 * 60 * 60,

    /** 1 week (604800 seconds) */
    WEEK: 7 * 24 * 60 * 60,

    /** 1 month (~30 days, 2592000 seconds) */
    MONTH: 30 * 24 * 60 * 60,

    /** 1 year (~365 days, 31536000 seconds) */
    YEAR: 365 * 24 * 60 * 60,
} as const;
